<template>
  <div>
    <div class="filters-container">
      <div class="date-buttons">
        <button
          :class="{ active: selectedButton === 'today' }"
          class="date-button"
          @click="selectButton('today')"
        >
          Hoje
        </button>
        <button
          :class="{ active: selectedButton === 'last7Days' }"
          class="date-button"
          @click="selectButton('last7Days')"
        >
          Últimos 7 dias
        </button>
        <button
          :class="{ active: selectedButton === 'last30Days' }"
          class="date-button"
          @click="selectButton('last30Days')"
        >
          Últimos 30 dias
        </button>
        <button
          :class="{ active: selectedButton === 'last6Months' }"
          class="date-button"
          @click="selectButton('last6Months')"
        >
          Últimos 6 meses
        </button>
        <date-picker v-model="filterRange" range placeholder="Intervalo de Datas" @change="selectButton('range')" />
      </div>
    </div>
    <div id="line-chart-content" class="white-panels">
      <canvas id="line-chart">&nbsp;</canvas>
    </div>

    <div class="wrapper">
      <div id="gender-chart-content" class="white-panelseg">
        <canvas id="gender-chart">&nbsp;</canvas>
      </div>
      <div id="ageChart-content" class="white-panelter">
        <canvas id="ageChart" width="600" height="600">&nbsp;</canvas>
      </div>
    </div>
    <div class="wrapper">
      <div id="security-chart-content" class="white-panelseg">
        <canvas id="security-chart">&nbsp;</canvas>
      </div>
      <div class="white-panelter">
        <div v-if="!loading" style="overflow-y: scroll;height: 100%;">
          <strong style="font-size: 1.25rem">Relação das Vítimas por Região</strong>
          <div class="table-container">
            <table>
              <thead>
                <tr>
                  <th>Ocorrências</th>
                  <th>Região</th>
                  <th>Vítimas</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(data, region) in victimsByRegion">
                  <tr class="region-row">
                    <td colspan="3">{{ region }}</td>
                  </tr>
                  <tr v-for="(victimCount, occurrence) in data" :key="occurrence">
                    <td>{{ occurrence }}</td>
                    <td>{{ region }}</td>
                    <td>{{ victimCount }}</td>
                  </tr>
                  <tr class="total-row">
                    <td colspan="2">Total em {{ region }}</td>
                    <td>{{ regionTotals[region] }}</td>
                  </tr>
                </template>
                <tr class="total-row">
                  <td colspan="2">Total Geral</td>
                  <td>{{ totalGeral }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div v-else class="is-loading"><div class="loader" /></div>
      </div>
    </div>
    <!-- <div class="search-boxs">
      <input type="text" placeholder="Buscar..." />
      <span class="icon">&#128269;</span>
    </div> -->
    <div v-for="(newAccordion, index) in newAccordions" :key="index">
      <div class="accordion">
        <div class="accordion-header" @click="toggleNewAccordion(index)">
          <h2>Insight Teste</h2>
          <span class="accordion-icon">{{ newAccordionsOpen[index] ? '-' : '+' }}</span>
        </div>
        <div v-show="newAccordionsOpen[index]" class="accordion-content">
          <div v-for="(insight, i) in iinsights" :key="i" class="input-section">
            <label for="insightTitle">Título do Insight</label>
            <input v-model="insight.title" type="text" placeholder="Digite o título do insight" />
            <p style="font-weight: bold; margin-top: 1.25rem">Fale com o GPT</p>
            <textarea
              v-model="insight.message"
              placeholder="Digite sua mensagem..."
              style="height: 6.25rem; overflow-y: auto"
            >&nbsp;</textarea>
            <p style="margin-top: 1.25rem">Variáveis</p>
            <textarea
              v-model="insight.variables"
              style="height: 6.25rem; overflow-y: auto"
            >&nbsp;</textarea>
            <div class="button-group" style="margin-top: 1.25rem">
              <button class="green-button" @click="saveAction(index)">Salvar</button>
              <button class="green-button" @click="cancelAction(index)">Cancelar</button>
              <button class="green-button" @click="confirmDeleteAction(index)">Excluir</button>
              <button class="green-button">Gerar Prompt</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import Chart from 'chart.js/auto'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/pt-br'
import moment from 'moment'

export default {
  components: { DatePicker },
  props: {
    occurrencesPerTypeAndMonth: {
      type: Object,
      default: () => {},
    },
    genders: {
      type: Object,
      default: () => {},
    },
    victimsByRegion: {
      type: Object,
      default: () => {},
    },
    ages: {
      type: Object,
      default: () => {},
    },
    percentSecuritySearch: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      selectedButton: 'last6Months',
      checkedT3: false,
      isOpen: false,
      filterRange: [],
      accordionOpen: false,
      loading: false,
      params: {
        initialDate: '',
        finalDate: '',
      },
      insights: [
        {
          title: '',
          message: '',
          variables: '',
        },
      ],
      newAccordions: [],
      newAccordionsOpen: [],
    }
  },
  computed: {
    regionTotals() {
      const totals = {}
      for (const region in this.victimsByRegion) {
        totals[region] = Object.values(this.victimsByRegion[region]).reduce((sum, count) => sum + count, 0)
      }
      return totals
    },
    totalGeral() {
      return Object.values(this.regionTotals).reduce((sum, count) => sum + count, 0)
    },
  },
  mounted() {
    this.renderChart() //gráfico de ocorrências
    this.renderGenderChart() //gráfico de vítimas
    this.createAgeChart() //gráfico faixa etária
    this.renderSecurityChart() //gráfico segurança
    //this.renderSecurityHistory() //gráfico serie histórica
  },
  methods: {
    async selectButton(button) {
      this.loading = true
      this.selectedButton = button
      try {
        switch (button) {
        case 'today':
          this.params.initialDate = moment().format('YYYY-MM-DD')
          this.params.finalDate = moment().format('YYYY-MM-DD')
          break
        case 'last7Days':
          this.params.initialDate = moment().subtract(7,'d').format('YYYY-MM-DD')
          this.params.finalDate = moment().format('YYYY-MM-DD')
          break
        case 'last30Days':
          this.params.initialDate = moment().subtract(30,'d').format('YYYY-MM-DD')
          this.params.finalDate = moment().format('YYYY-MM-DD')
          break
        case 'last6Months':
          this.params.initialDate = moment().subtract(6,'M').format('YYYY-MM-DD')
          this.params.finalDate = moment().format('YYYY-MM-DD')
          break
        case 'range':
          if (this.filterRange.length > 0) {
            this.params.initialDate = moment(this.filterRange[0]).format('YYYY-MM-DD')
            this.params.finalDate = moment(this.filterRange[1]).format('YYYY-MM-DD')
          }
          break
        }

        document.getElementById('line-chart-content').innerHTML = '<div class="is-loading"><div class="loader"></div></div>'
        document.getElementById('gender-chart-content').innerHTML = '<div class="is-loading"><div class="loader"></div></div>'
        document.getElementById('ageChart-content').innerHTML = '<div class="is-loading"><div class="loader"></div></div>'
        document.getElementById('security-chart-content').innerHTML = '<div class="is-loading"><div class="loader"></div></div>'

        await axios.get('/security/statistcs', { params: this.params }).then((resp) => {
          console.log(resp)
          this.occurrencesPerTypeAndMonth = resp.data.occurrencesPerTypeAndMonth
          this.genders = resp.data.genders
          this.ages = resp.data.ages
          this.victimsByRegion = resp.data.victimsByRegion
          this.percentSecuritySearch = resp.data.percentSecuritySearch
        }).finally(() => {
          this.renderChart() //gráfico de ocorrências
          this.renderGenderChart() //gráfico de vítimas
          this.createAgeChart() //gráfico faixa etária
          this.renderSecurityChart() //gráfico segurança
          this.loading = false
        })

      } catch (error) {
        console.error('Erro ao obter dados:', error)
      }
    },
    renderChart() {
      document.getElementById('line-chart-content').innerHTML = '<canvas id="line-chart">&nbsp;</canvas>'
      const ctx = document.getElementById('line-chart').getContext('2d')
      new Chart(ctx, {
        type: 'line',
        data: this.occurrencesPerTypeAndMonth,
        options: {
          responsive: true,
          plugins: {
            title: {
              display: true,
              text: 'Ocorrências',
              align: 'start',
              font: {
                size: 25,
              },
            },
            legend: {
              position: 'top',
              padding: 20,
            },
          },
          scales: {
            x: {
              title: {
                display: true,
                text: 'Mês',
              },
            },
            y: {
              title: {
                display: true,
                text: 'Quantidade de Ocorrências',
              },
              beginAtZero: true,
            },
          },
        },
      })
    },
    renderGenderChart() {
      document.getElementById('gender-chart-content').innerHTML = '<canvas id="gender-chart">&nbsp;</canvas>'
      const ctx = document.getElementById('gender-chart').getContext('2d')
      new Chart(ctx, {
        type: 'doughnut',
        data:
        this.genders,
        options: {
          plugins: {
            title: {
              display: true,
              text: 'Gênero das Vítimas',
              align:'start',
              font: {
                size: 20,
              },
              padding: {
                bottom: 20,
              },
            },
          },
        },
      })
    },
    createAgeChart() {
      document.getElementById('ageChart-content').innerHTML = '<canvas id="ageChart">&nbsp;</canvas>'
      const ctx = document.getElementById('ageChart').getContext('2d')
      new Chart(ctx, {
        type: 'bar',
        data:
        this.ages,
        options: {
          responsive: true,
          maintainAspectRatio: true,
          scales: {
            y: {
              beginAtZero: true,
            },
          },
          plugins: {
            title: {
              display: true,
              text: ['Faixa Etária', 'Vítimas por bairros'],
              align:'start',
              font: {
                size: 18,
              },
            },
          },
        },
      })
    },
    renderSecurityChart() {
      document.getElementById('security-chart-content').innerHTML = '<canvas id="security-chart">&nbsp;</canvas>'
      const ctx = document.getElementById('security-chart').getContext('2d')
      new Chart(ctx, {
        type: 'doughnut',
        data: this.percentSecuritySearch,
        options: {
          plugins: {
            title: {
              display: true,
              text: 'Você se sente seguro no centro de Recife?',
              align:'start',
              font: {
                size: 20,
              },
              padding: {
                bottom: 20,
            },
            },
            legend: {
              display: true,
              position: 'top',
              },
            legend: {
              display: true,
              position: 'top',
            },
          },
        },
      })
    },

    renderGuardChart() {
      const ctx = document.getElementById('guardchart').getContext('2d')
      new Chart(ctx, {
        type: 'bar',
        data: {
          labels: ['2023', '2024', '2025'],
          datasets: [
            {
              label: 'Atual',
              data: [100, 200, 300],
              backgroundColor: 'rgba(211, 211, 211, 5.5)',
              barThickness: 30,
            },
            {
              label: 'Recomendado',
              data: [500, 600, 700],
              backgroundColor: 'rgba(147, 112, 219, 5.5)',
              barThickness: 30,
            },
          ],
        },
        options: {
          scales: {
            y: {
              beginAtZero: true,
              title: {
                display: true,
              },
            },
            x: {
              title: {
                display: true,
              },
            },
          },
          plugins: {
            title: {
              display: true,
              text: 'Efetivo da Guarda Municipal',
              align:'start',
              font: {
                size: 25,
              },
            },
            legend: {
              display: true,
              position: 'top',
            },
          },
        },
      })
    },

    toggleAccordion() {
      this.accordionOpen = !this.accordionOpen
    },

    saveAction(index) {
      alert('Salvando o insight ' + (index + 1))
    },

    cancelAction(index) {
      alert('Cancelando o insight ' + (index + 1))
    },

    confirmDeleteAction(index) {
      if (window.confirm('Tem certeza que deseja excluir o Insight?')) {
        this.deleteAction(index)
        this.$set(this.newAccordionsOpen, index, false)
      }
    },

    deleteAction(index) {
      this.newAccordions.splice(index, 1)
    },

    toggleNewAccordion(index) {
      this.$set(this.newAccordionsOpen, index, !this.newAccordionsOpen[index])
    },

    addNewAccordion() {
      this.newAccordions.push({})
      this.newAccordionsOpen.push(false)
    },

    getOcurrences() {

    },
  },
}
</script>

<style>
.select {
  height: 2.1875rem;
  border-radius: .3125rem;
}
#line-chart {
  width: 81.25rem;
  height: 6.25rem;
}
.white-panels {
  background-color: white;
  border-radius: 1.25rem;
  padding: 1.25rem;
  box-shadow: 0 .125rem .3125rem rgba(0, 0, 0, 0.2);

  height: 53.125rem;
  margin-top: 1.875rem;
  box-sizing: border-box;
  width: 100%;
}
body {
  margin: 0;
  padding: 0;
}

.noScroll {
  overflow: hidden;
}

.is-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.is-loading .loader {
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #333;
  width: 28px;
  height: 28px;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.filters-container {
  display: flex;
  gap: 16px;
  margin-top: 1.25rem;
}

.filter-input {
  position: relative;
  display: inline-block;
  margin-right: .625rem;
}

.filter-input i {
  position: absolute;
  top: 50%;
  right: .625rem;
  transform: translateY(-50%);
  cursor: pointer;
}
.white-panelvpg {
  position: relative;
  background-color: white;
  border-radius: 1.25rem;
  padding: 1.25rem;
  box-shadow: 0 .125rem .3125rem rgba(0, 0, 0, 0.2);
  width: 100%;
  height: 50rem;
  top: 1.25rem;
}
.search-boxs {
  position: absolute;
  right: .625rem;
  top: .625rem;
  width: 18.75rem;
  height: 2.5rem;
}
.search-boxs input[type='text'] {
  width: 100%;
  height: 100%;
  padding: .625rem 1.25rem .625rem 2.5rem;
  box-sizing: border-box;
  border: .125rem solid #ccc;
  border-radius: .625rem;
}
.search-boxs .icon {
  position: absolute;
  top: 50%;
  left: .625rem;
  transform: translateY(-50%);
  font-size: 1.25rem;
  color: #ccc;
}
.wrapper {
  display: flex;
  margin-top: 1.25rem;
}

.white-panelseg,
.white-panelter,
.white-panelrel {
  background-color: white;
  border-radius: 1.25rem;
  padding: 1.25rem;
  box-shadow: 0 .125rem .3125rem rgba(0, 0, 0, 0.2);
  width: 50%;
  height: 37.5rem;
  margin: 0 .625rem;
}
.panels-container {
  display: flex;
}

.white-panelsds,
.white-panelegm {
  background-color: white;
  border-radius: 1.25rem;
  padding: 1.25rem;
  box-shadow: 0 .125rem .3125rem rgba(0, 0, 0, 0.2);
  width: 50%;
  height: 25rem;
  margin-top: 2.5rem;
}

.white-panelegm {
  margin-left: 2.5rem;
}

.table-container {
    height: calc(100% - 3.75rem); /* Ajusta a altura para incluir padding e espaço do título */
    overflow-y: auto;
}
table {
  margin-top: 1.25rem;
  width: 100%;
  border-collapse: collapse;
}
th, td {
  padding: .625rem;
  text-align: left;
  border-bottom: .0625rem solid #ddd;
}
th {
  background-color: #f2f2f2;
}
.total-row {
  font-weight: bold;
  background-color: #e9e9e9;
}
.title {
  font-size: 1.25rem;
  margin-bottom: 1.25rem;
}
.region-row {
  font-weight: bold;
  background-color: #f9f9f9;
}
</style>
